import React from 'react';
import { translate } from '../../../../../Services/translation';
import { ACCORDION_PANEL_MEASUREMENTS } from '../../../../Constants';

const Content = ({ type, name, viewName, value, args, url, quantity, isProductDocument, articleNumber, fileExtension, fileSize  }) => {
  const renderListItem = () => (
    <li className="accordion-tab__description__list-item">
      <span className="accordion-tab__description__list-item__name">
        {name}
      </span>
      <span className="accordion-tab__description__list-item__value">
        {value}
      </span>
    </li>
  );

  if (type === ACCORDION_PANEL_MEASUREMENTS) return renderListItem();

  return isProductDocument ? (
    <div className="accordion-tab__product-documents">
      <div>
        <div className="accordion-tab__panel__text">
          <a>{name}</a>
        </div>
        <div className="accordion-tab__product-documents__info">
          {translate('product.information.documenttext')}  ({fileExtension})  {fileSize}
        </div>
      </div>
      <div>
        <a href={url} target="_blank" className="accordion-tab__product-documents__show">{translate('product.information.documentshow')}</a>
      </div>
    </div>
  ) :
  url != null && quantity > 0 ? (
    <div className="accordion-tab__panel__text">          
        <p>
          <a className="accordion-tab__panel__innertext" href={url} target="_blank">
            <span className="accordion-tab__panel__innertext__first">{articleNumber}</span>
            <span className="accordion-tab__panel__innertext__last">{name}</span>
            <span className="accordion-tab__panel__innertext__quantity">{quantity} {translate('content.product-bundle.quantity-show')}</span>
          </a>
        </p>
    </div>
  ) : (name &&    
    <div className="accordion-tab__panel__text ">
      <p className="accordion-tab__panel__innertext accordion-tab__panel__text__specification">
        <span>{name}</span>
        <span>{value}</span>
      </p>
    </div>
  )
};

export default Content;
